export enum ErrorType {
  GeneralSystemError = 'generalsystemerror',
  PageNotFound = 'pagenotfound',
  AccountSelectionError = 'accountselectionerror', //same as general system error but hide navbar menu items
  OktaCallbackGenericError = 'callbackgenericerror',
  OktaCallbackTimezoneError = 'callbacktimezoneerror'
}
